:host {
  --av-container-round-lg-padding: calc(1em * 0.6667); //10px;
}

.av-button {
  padding: 10px 20px;
  color: white;
  border-radius: var(--av-border-radius-button);
  border: 0;
  cursor: pointer;
  transition: transform 0.2s ease-out;
  font-weight: bold;
  font-size: var(--av-font-size);
  position: relative;
  display: inline-flex;
  box-sizing: border-box;
  justify-content: center;
  font-size: 0.9em;
  text-decoration: none;
  font-family: var(--av-font-family);
  flex-direction: row;
  gap: 8px;
  align-items: center;

  @include darken-on-hover;

  &:focus-visible {
    outline-offset: 2px;
    outline-color: var(--av-color-focus-outline);
  }

  &:after {
    border-radius: var(--av-border-radius-button);
  }

  av-spinner {
    transform: scale(0.3);
    width: 28px;
    height: 28px;
    position: absolute;
    right: 10px;
    top: 0;
  }

  &.av-button-flat {
    &.av-button-size-lg {
      av-spinner {
        top: -4px;
      }
    }

    &.av-button-size-md {
      av-spinner {
        transform: scale(0.24);
        top: -8px;
      }
    }
    &.av-button-size-sm {
      av-spinner {
        transform: scale(0.2);
        top: -9px;
      }
    }
  }

  &.av-button-background {
    &.av-button-size-xs,
    &.av-button-size-sm,
    &.av-button-size-md,
    &.av-button-size-lg {
      padding: 0;
      display: flex;
    }
  }

  &.av-button-size-md {
    padding: 5px 10px;
  }

  &.av-button-size-sm {
    padding: 3px 6px;
  }

  &.av-button-loading {
    transition: padding 0.2s ease-out;
    padding-right: 40px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.8;

    &:hover {
      background-color: none;
    }

    &.av-button-round,
    &.av-button-flat {
      // opacity: 1;
      background-color: $gray;
    }
  }
}

.av-button-bordered {
  border: 1px solid var(--av-card-color);

  &.av-button-color-link {
    border-color: var(--av-card-link-color);
  }
}

.av-button-round {
  border: 0;
  background: transparent;
  border-radius: $container-width;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1em;
  &:after {
    border-radius: 50%;
  }

  img {
    width: 100%;
  }

  &.av-button-size-lg {
    width: $container-width;
    height: $container-width;
    padding: var(--av-container-round-lg-padding);
  }

  // &.av-button-size-md {
  //   width: calc(var(--av-font-size) * 2.8); // 42px;
  //   height: calc(var(--av-font-size) * 2.8); // 42px;
  //   padding: calc(var(--av-font-size) * 0.8); // 13px;
  // }

  &.av-button-size-xs {
    width: calc(1em * 1.334); // 20px;
    height: calc(1em * 1.334); // 20px;
    padding: calc(1em * 0.2667); // 4px;
  }

  &.av-button-size-sm {
    width: calc(1em * 1.7334); // 26px;
    height: calc(1em * 1.7334); // 26px;
    padding: calc(1em * 0.2667); // 4px;
  }

  &.av-button-size-md {
    width: calc(1em * 2.1334); // 32px;
    height: calc(1em * 2.1334); // 32px;
    padding: calc(1em * 0.2667); // 4px;
  }

  &.av-button-mobile {
    &.av-button-size-lg {
      padding: 0.8em; // 12px;
    }
  }

  av-spinner {
    transform: translateX(-50%) scale(0.4);
    left: 50%;
    margin-left: -10px;
  }
}

.av-button-size-block {
  width: 100%;
}

.av-button-color-basic {
  background-color: transparent;
  color: var(--av-card-color);
}

.av-button-color-link {
  background-color: transparent;
  color: var(--av-card-link-color);
}

.av-button-color-primary {
  background: var(--av-color-primary);
  color: var(--av-color-primary-contrast);
}

.av-button-color-accent {
  background: var(--av-color-accent);
  color: var(--av-color-accent-contrast);
}

.av-button-color-danger {
  background: var(--av-color-danger);
  color: var(--av-color-danger-contrast);
}

.av-button-color-warning {
  background: var(--av-color-warning);
  color: var(--av-color-danger-warning);
}

.av-button-color-success {
  background: var(--av-color-success);
  color: var(--av-color-danger-success);
}

.av-button-tooltip {
  @include tooltip;

  &.av-button-tooltip-position-right {
    right: 0;
  }

  &.av-button-tooltip-position-left {
    right: 30px;
    top: auto;
    bottom: 0;
    margin-bottom: -20px;
  }
}

.av-button:hover .av-button-tooltip {
  visibility: visible;
  opacity: 1;
  top: -25px;
  &.av-button-tooltip-position-left {
    margin-bottom: 0;
    top: auto;
  }
}

av-asset {
  width: 100%;
}
